const { buildErrResponse } = require("../_utils/utils");
const { BASE_URL, BASE_URL_DEV } = require("../_constants/urlConstants");
const { default: Axios } = require("axios");

export const GuaranteeService = {
  getAllGuarantees,
  getGuaranteesWithParams,
  getGuaranteesBySite,
  getGuaranteeById,
  getGuaranteeByProductId,
  createGuarantee,
  updateGuarantee,
  updateStatusGuarantee,
};

function getAllGuarantees() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/guarantee`)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getGuaranteesWithParams(params) {
  // const {
  //   siteId,
  //   statusGuaranteeId,
  //   productTypeId,
  //   startDate,
  //   endDate,
  //   imeiCode,
  // } = params;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/guarantee`, {
      params,
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getGuaranteesBySite(siteId) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/guarantee/by-site?siteId=${siteId}`)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getGuaranteeById(id) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/guarantee/by-id?id=${id}`)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getGuaranteeByProductId(id) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/guarantee/by-product-id?id=${id}`)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function createGuarantee(body) {
  return new Promise((resolve, reject) => {
    Axios.post(`${BASE_URL_DEV}/guarantee`, body)
      .then((resp) => resolve(resp))
      .catch((err) => reject(buildErrResponse(err)));
  });
}

function updateGuarantee(body, serviceTicket) {
  return new Promise((resolve, reject) => {
    Axios.put(
      `${BASE_URL_DEV}/guarantee?serviceTicketId=${serviceTicket}`,
      body
    )
      .then((resp) => resolve(resp))
      .catch((err) => reject(buildErrResponse(err)));
  });
}

function updateStatusGuarantee(body, id) {
  return new Promise((resolve, reject) => {
    Axios.patch(`${BASE_URL_DEV}/guarantee?id=${id}`, body)
      .then((resp) => resolve(resp))
      .catch((err) => reject(buildErrResponse(err)));
  });
}
